import { scCoreModule } from '../core/core.module';
import { DatePickerComponent } from './date-picker.component';
import { FilterDimensionComponent } from './filter-dimension.component';
import { FilterDimensionNodeComponent } from './filter-dimension-node.component';
import { FilterEditorModalService } from './editor/filter-editor-modal.service';
import { CatalogComponent } from './catalog/catalog.component';
import { CatalogNodeComponent } from './catalog/catalog-node.component';
import { CatalogSearchComponent } from './catalog/catalog-search.component';
import { FilterSearchComponent } from './filter-search.component';
import { FilterDimensionsComponent } from './filter-dimensions.component';
import { FilterDrillDownDraggableComponent } from './filter-drilldown-draggable.component';
// import { FilterCardEditorModalService } from './editor/filter-card-editor-modal.service';
import { FiltersCutEditorModalService } from './editor/cut-editor/filters-cut-editor-modal.service.js';
import { RulesEditorModalService } from './editor/rules-editor/rules-editor-modal.service.js';
import { PlanEditorModalService } from './editor/plan-editor/plan-editor-modal.service.js';
import { DLPBuilderComponent } from './dlp-builder/dlp-builder.component';
import { QueryBuilderContainerComponent } from './query-builder/query-builder-container.component';
import { QueryBuilderComponent } from './query-builder/query-builder.component';
import { ValueBuilderComponent } from './dlp-builder/value-builder.component';
import { FilterValueInputComponent } from './query-builder/filter-value-input.component';
import { QueryBuilderNodeComponent } from './query-builder/query-builder-node.component';
import { FilterEditorService } from './editor/filter-editor.service';
// import { FilterCardEditorCellComponent } from './editor/filter-card-editor-cell.component';
import { OcrFilterEditorComponent } from './editor/spec-forms/ocr-filter-editor.component';
// import { StamprecognitionFilterEditorComponent } from './editor/spec-forms/stamprecognition-filter-editor.component';
import { StamprecognitionFilterEditorComponent, ngThumbComponent } from './editor/spec-forms/stamprecognition-filter-editor.component';
import { ContentprocessingFilterEditorComponent } from './editor/spec-forms/contentprocessing-filter-editor.component';
import { GraphicObjectsFilterEditorDirective } from './editor/spec-forms/graphicobjects-filter-editor.component';
import { CatalogNodeDragService } from './catalog/catalog-node-drag.service';
import { EmailTempleteComponent } from './editor/email-templete/email-templete.component';
import { ThresholdComponent } from './editor/threshold/threshold.component';
import { EmailsComponent } from './editor/emails/emails.component';
import { AssignAgentConfigTabComponent } from './editor/tabs/assign-agent-config-tab.component';
import { FiltersTabComponent } from './editor/tabs/filters-tab.component';
import { NotifyTabComponent } from './editor/tabs/notify-tab.component';
import { GeneralReportComponent } from './editor/general-report/general-report.component';
import { SpeechRecognitionTabDirective } from './editor/tabs/speech-recognition-tab.component';


export const scFilterModule = 'sc-filter';

angular.module(scFilterModule, [scCoreModule])
  .service('CatalogNodeDragService', CatalogNodeDragService)
  .service('FilterEditorService', FilterEditorService)
  .service('FilterEditorModalService', FilterEditorModalService)
  .service('FiltersCutEditorModalService', FiltersCutEditorModalService)
  .service('RulesEditorModalService', RulesEditorModalService)
  .service('PlanEditorModalService', PlanEditorModalService)
  .component('scOcrFilterEditor', OcrFilterEditorComponent)
  .component('scStamprecognitionFilterEditor', StamprecognitionFilterEditorComponent)
  .component('scContentprocessingFilterEditor', ContentprocessingFilterEditorComponent)
  .directive('scGraphicObjectsFilterEditor', GraphicObjectsFilterEditorDirective)
  .component('scCatalogSearch', CatalogSearchComponent)
  .component('scDatePicker', DatePickerComponent)
  .component('scCatalog', CatalogComponent)
  .component('scCatalogNode', CatalogNodeComponent)
  .component('scFilterDimension', FilterDimensionComponent)
  .component('scFilterDimensionNode', FilterDimensionNodeComponent)
  .directive('scFilterDimensions', FilterDimensionsComponent)
  .directive('scFilterSearch', FilterSearchComponent)
  .component('scFilterDrillDownDraggable', FilterDrillDownDraggableComponent)
  .component('scQueryBuilder', QueryBuilderComponent)
  .component('scQueryBuilderContainer', QueryBuilderContainerComponent)
  .component('scDlpBuilder', DLPBuilderComponent)
  .component('scQueryBuilderNode', QueryBuilderNodeComponent)
  .component('scValueBuilder', ValueBuilderComponent)
  .component('scFilterValueInput', FilterValueInputComponent)
  .component('scEmails', EmailsComponent)
  .component('scGeneralReport', GeneralReportComponent)
  .directive('scEmailTemplete', EmailTempleteComponent)
  .directive('scThreshold', ThresholdComponent)
  .directive('scAssignAgentConfigTab', AssignAgentConfigTabComponent)
  .directive('scFiltersTab', FiltersTabComponent)
  .directive('scNotifyTab', NotifyTabComponent)
  .directive('scSpeechRecognitionTab', SpeechRecognitionTabDirective)
  .directive('ngThumb', ngThumbComponent.directiveFactory)
  .filter('to_trusted', ['$sce', function($sce){
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }])
;



// WEBPACK FOOTER //
// ./src/filter/filter.module.js